/**
 * page : 주요실적 > 지적측량
 */

import { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import * as zy from '../common/zeroyear-1.0.0';
import { MDBRipple } from 'mdb-react-ui-kit';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Swal from "sweetalert2";
import '../assets/css/card.css'
let sessionStorage = window.sessionStorage;

const dataObject = {PERF_DV: '10',PERF_CONSTR_NM: '',DEPT_NM: '',NECESS_PRID: '',PERF_CONTENT: '',PERF_IMG: ''};
export default function PerfPointPage () {
    const [admin, setAdmin] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [dataTemp, setDataTemp] = useState([]);
    const [perfList, setPerfList] = useState([]);
    const [perfImg, setPerfImg] = useState([]);
    const [editImgs, setEditImgs] = useState([]);
    const [data, setData] = useState(dataObject);
    const [showModal, setShowModal] = useState(false);
    const [showAlertSave, setShowAlertSave] = useState(false); // 수정완료 alert
    const [validated, setValidated] = useState(false);
    const selectAll = () => {
        zy.select('selectPerfAll', ['10'],(itemA) => {
            zy.select('selectPerfImg', ['10'], (item) => {
                setPerfImg(item);
                setPerfList(itemA);
                setLoading(false);
            });
        });
    };
    useEffect(()=>{
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    },[]);
    /**
     * close modal
     */
    const closeModal = () => {
        setValidated(false);
        setShowModal(false);
        setEditImgs([]);
    };
    /**
     * open modal
     */
    const openModal = () => {
        setValidated(false);
        setShowModal(true);
    };

    /**
     * 시공명칭 change event
     */
    const changePerfConstr = (event) => {
        setData({...data, PERF_CONSTR_NM: event?.target.value});
    }
    /**
     * 부서 change event
     */
    const changeDeptNm = (event) => {
        setData({...data, DEPT_NM: event?.target.value});
    }
    /**
     * 제목 change event
     */
    const changeNecess = (event) => {
        setData({...data, NECESS_PRID: event?.target.value});
    }
    /**
     * 내용 change event
     */
    const changeContent = (event) => {
        setData({...data, PERF_CONTENT: event?.target.value});
    }
    /**
     * 이미지 파일 change event
     */
    const changeImage = (event) => {
        let reader = new FileReader();
        if (event.target.files[0].size > 2621440) {
            event.target.value = "";
            Swal.fire({
                icon: "warning",
                title: "이미지 용량을 확인해주세요.",
                text: "이미지 용랑은 2.5MB 이하로 등록이 가능합니다.",
            }).then((res) => {
                if (res.isConfirmed) { }
                else{}
            });
            return false;
        } else {
            reader.readAsDataURL(event.target.files[0]);
        }
        reader.onload = function (e) {
            // setData({...data, PERF_IMG: e.target.result});
            setEditImgs([...editImgs, {...data, PERF_IMG_NO: editImgs.length+1, PERF_IMG: e.target.result}])
        }
    }
    const deleteImage = (event) => {
        setEditImgs(editImgs.filter((o) => o.PERF_IMG_NO != event.target.dataset.no))
        event.preventDefault();
        event.stopPropagation();
    }
    /**
     * 등록 event handler
     */
    const saveDesign = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            // validate
            event.preventDefault();
            event.stopPropagation();
        } else {
            // 저장
            event.preventDefault();
            event.stopPropagation();
            zy.create('insertPerf', [
                data.PERF_DV, data.PERF_DV, data.PERF_CONSTR_NM, data.DEPT_NM, data.NECESS_PRID, data.PERF_CONTENT
            ], (item) => {
                if (item.affectedRows > 0) {
                    editImgs.forEach((img, iidx) => {
                        zy.create('insertPerfImg', [
                            item.insertId, item.insertId, img.PERF_DV, img.PERF_DV, img.PERF_IMG
                        ], (itemB) => {
                            // 저장 완료
                            if (iidx+1 == editImgs.length) {
                                closeModal();
                                selectAll();
                            }
                        });
                    });
                }
            });
        }
        setValidated(true);
    };
    /**
     * img 클릭
     */
    const imgClick = (event) => {
        navigate(`/PerfPointDetailRoute/${event.target.id}`);
    };
    const closeAlertSave = () => { setShowAlertSave(false); } // 수정완료 alert 닫기
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">주요실적</a></li>
                        <li>지적측량</li>
                    </ol>
                    <h2>지적측량</h2>
                </div>
            </section>
            <section id="portfolio" className="portfolio">
                <div className="container">
                    <div className="row gy-4">
                        <div className="row portfolio-container">
                        {
                            loading ? (<><hr></hr><div style={{textAlign: 'center'}}>사진을 불러오고 있습니다...</div><hr style={{marginTop: '20px'}}></hr></>) :
                            perfList.length === 0 ? (
                                <><hr></hr><div style={{textAlign: 'center'}}>등록 된 사진이 없습니다.</div><hr style={{marginTop: '20px'}}></hr></>
                            ) : 
                            <Row xs={2} md={4} className="g-4">
                                {perfList.map((perf) => {
                                    let imgs = perfImg.filter((img) => img.PERF_SEQ === perf.PERF_SEQ)
                                    return (
                                        <Col key={perf.PERF_SEQ}>
                                            <Card className='perf-card'>
                                                <MDBRipple rippleTag='div' className='bg-image hover-overlay hover-zoom hover-shadow'>
                                                    <Card.Img id={perf.PERF_SEQ} variant="top" src={imgs[0]?.PERF_IMG} onClick={imgClick} style={{cursor: 'pointer'}} className="perf-card-img w-100"/>
                                                    <a onClick={imgClick}>
                                                        <div id={perf.PERF_SEQ} className='mask' style={{ backgroundColor: 'rgba(57, 192, 237, 0.2)' }}></div>
                                                    </a>
                                                </MDBRipple>
                                                <Card.Body>
                                                <Card.Title>{perf.PERF_CONSTR_NM}</Card.Title>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                })}
                            </Row>
                        }
                        </div>
                    </div>
                    <hr style={{marginTop: '30px'}}></hr>
                    {
                        admin ? <button className="btn-normal" onClick={openModal} style={{float: 'right'}}>이미지 등록하기</button> : null
                    }
                </div>
            </section>

            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated} onSubmit={saveDesign}>
                    <Modal.Header closeButton>
                    <Modal.Title>이미지 등록</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="Perf_DV">
                            <Form.Label>시공명칭</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changePerfConstr}
                                required/>
                            <Form.Control.Feedback type="invalid">시공명칭을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_REG_NM">
                            <Form.Label>업무 담당부서</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changeDeptNm}
                                required/>
                            <Form.Control.Feedback type="invalid">업무 담당부서를 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                            <Form.Label>분류</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                defaultValue={'지적측량'} disabled readOnly/>
                            <Form.Control.Feedback type="invalid">분류를 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                            <Form.Label>소요기간</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={changeNecess}
                                placeholder=""
                                required/>
                            <Form.Control.Feedback type="invalid">소요기간을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_CONTENT">
                            <Form.Label>내용</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeContent}
                                rows={4}
                                required/>
                            <Form.Control.Feedback type="invalid">내용을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                            <Form.Label>이미지 첨부</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/gif, image/jpeg, image/png"
                                onChange={changeImage}
                                placeholder=""
                                required/>
                            <Form.Control.Feedback type="invalid">이미지를 선택해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <div style={{marginBottom: '15px'}}>
                            <Row xs={2} md={4} className="g-4">
                                    {
                                        editImgs.map((perf) => {
                                            if (perf.DEL_YN !== 'Y') {
                                                return (
                                                    <Col key={perf.PERF_IMG_NO}>
                                                        <Card className='perf-card'>
                                                            <div className="perf-cards">
                                                                <Card.Img variant="top" src={perf.PERF_IMG} className="perf-card-img-eidt w-100"/>
                                                                <button className='perf-card-del' data-no={perf.PERF_IMG_NO} onClick={deleteImage}>X</button>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })
                                    }
                            </Row>
                        </div>
                        <Modal.Footer>
                            <button className="btn-cancel" onClick={closeModal}>닫기</button>
                            <button className="btn-normal" type="submit">등록</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
            <Modal 
                show={showAlertSave}
                onHide={closeAlertSave}
                backdrop="static"
                keyboard={false}
                >
                <Modal.Header closeButton>
                <Modal.Title>안내</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    등록 되었습니다.
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn-cancel" onClick={closeAlertSave}>닫기</button>
                </Modal.Footer>
            </Modal>
        </main>
        </>
    );
}